import dayjs from 'dayjs';

const SHORT_DATE_FORMAT = 'MM/DD/YYYY';

export const formatDate = (date?: string) => dayjs(date).format(SHORT_DATE_FORMAT);

export const formatTime = (time?: string) =>
  dayjs(`${formatDate()} ${time}`, `${SHORT_DATE_FORMAT} HH:mm:ss`).format('ha');

export type DayOfWeek =
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | 'SUNDAY';

export const days: { value: DayOfWeek; label: string }[] = [
  {
    value: 'MONDAY',
    label: 'Monday',
  },
  {
    value: 'TUESDAY',
    label: 'Tuesday',
  },
  {
    value: 'WEDNESDAY',
    label: 'Wednesday',
  },
  {
    value: 'THURSDAY',
    label: 'Thursday',
  },
  {
    value: 'FRIDAY',
    label: 'Friday',
  },
  {
    value: 'SATURDAY',
    label: 'Saturday',
  },
  {
    value: 'SUNDAY',
    label: 'Sunday',
  },
];
